import { frequencies } from '@features/SendoutCreationModal/components/SendMessageModal/data/frequency';
import { Form, Select } from 'antd';

const { useFormInstance } = Form;

export const FrequencySelect = () => {
  const form = useFormInstance();

  const onChange = (value: number) => form.setFieldsValue({ frequency: value });

  return (
    <Form.Item
      wrapperCol={{ offset: 1, span: 32 }}
      label="Периодичность"
      colon
      name="frequency"
    >
      <Select
        options={frequencies}
        style={{ width: '100%' }}
        onChange={onChange}
      />
    </Form.Item>
  );
};
